__turbopack_context__.v({
  "boxContentElement": "PhotonInTheBox-module__JEYBpa__boxContentElement",
  "boxContentElementWrapper": "PhotonInTheBox-module__JEYBpa__boxContentElementWrapper",
  "contents": "PhotonInTheBox-module__JEYBpa__contents",
  "heading": "PhotonInTheBox-module__JEYBpa__heading",
  "root": "PhotonInTheBox-module__JEYBpa__root",
});
